// extracted by mini-css-extract-plugin
export default {"wrapper":"AuthWrapper_wrapper__O8ZV3","content":"AuthWrapper_content__gwJur","background":"AuthWrapper_background__gJIbv"};